import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAlertTriangle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M9.335 1.5c.787 0 1.516.41 1.926 1.087l6.359 10.615c.4.692.402 1.545.006 2.24-.396.694-1.13 1.126-1.938 1.135H2.975c-.8-.009-1.535-.441-1.93-1.136-.396-.694-.394-1.547.012-2.25L7.409 2.588C7.82 1.91 8.55 1.5 9.335 1.5zm0 1.5c-.261 0-.504.136-.64.36L2.35 13.952c-.133.23-.134.515-.002.747.132.231.377.375.635.378H15.68c.266-.003.51-.147.643-.378.132-.232.131-.516.004-.737L9.977 3.361C9.84 3.137 9.597 3 9.335 3zm-.53 8.547c.293-.293.768-.293 1.06 0 .293.293.293.767 0 1.06-.292.293-.767.293-1.06 0-.293-.293-.293-.767 0-1.06zm.53-5.47c.414 0 .75.336.75.75v3c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-3c0-.414.336-.75.75-.75z"
	})
});
export default SvgAlertTriangle;
